module.exports = __webpack_public_path__ + "img/roadmap-2-bg.b66565a5.png";